import {
  DEL_CUSTOMER_BY_ID,
  GET_CUSTOMER_BY_BRANCH_ID,
} from 'apis/GraphQL/Queries/customerQuery';
import { CUSTOMER_VARIABLE } from 'apis/GraphQL/Variables/customer';
import {
  ICheckCreateSalePlan,
  ICheckExistSalePlan,
  ICreateSalePlanning,
  IExportSalePlan,
  IUpdateManySalePlanningCustomerRevenue,
  SALE_PLAN_VARIABLE,
  VARIABLE_CREATE_DASHBOARD_TEAM_SALE,
  VARIABLE_GET_DASHBORAD_TEAMSALE,
} from 'apis/GraphQL/Variables/salePlan';
import dayjs from 'dayjs';
import { IGetCustomerByBranchId } from 'interfaces/Customer';
import { IUpdateSalePlanningIndexItem } from 'interfaces/SaleLine';
import {
  ICreateSalePlanningAuto,
  IDeleteCustomerInSalePlan,
  IGetDashboardTeamSale,
  IUpdateSalePlanning,
} from 'interfaces/SalePlanning';
import * as SalePlanQuery from './GraphQL/Queries/salePlan';
import { IParams } from './GraphQL/Variables/salePlan';
import axiosGraphQL from './GraphQL/axiosGraphQL';

const SalePlanApi = {
  getSalePlanList: async (params: IParams) => {
    return await axiosGraphQL.post('/graphql', {
      query: SalePlanQuery.GET_ALL_SALE_PLAN,
      variables: SALE_PLAN_VARIABLE.getSalePlan(params),
    });
  },
  getSalePlanListNew: async (params: IParams) => {
    return await axiosGraphQL.post('/graphql', {
      query: SalePlanQuery.GET_ALL_SALE_PLAN_NEW,
      variables: SALE_PLAN_VARIABLE.getSalePlanNew(params),
    });
  },
  exportSalePlanList: (params: IExportSalePlan) => {
    return axiosGraphQL.post('/graphql', {
      query: SalePlanQuery.EXPORT_SALE_PLANNING,
      variables: SALE_PLAN_VARIABLE.exportSalePlan(params),
    });
  },
  updateSalePlanning: async (params: IUpdateSalePlanning) => {
    return await axiosGraphQL.post('/graphql', {
      query: SalePlanQuery.UPDATE_SALE_PLANNING,
      variables: SALE_PLAN_VARIABLE.updateSalePlanning(params),
    });
  },
  getCustomersInSalePlan: async (params: IGetCustomerByBranchId) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_CUSTOMER_BY_BRANCH_ID,
      variables: CUSTOMER_VARIABLE.getCustomerByBranchId(params),
    });
  },

  updateSalePlanningIndexItem: async (
    params: IUpdateSalePlanningIndexItem[],
  ) => {
    return await axiosGraphQL.post('/graphql', {
      query: SalePlanQuery.UPDATE_SALE_PLANNING_INDEX,
      variables: {
        input: params,
      },
    });
  },

  createSalePlanning: async (params: ICreateSalePlanning) => {
    return await axiosGraphQL.post('/graphql', {
      query: SalePlanQuery.CREATE_SALE_PLANNING,
      variables: SALE_PLAN_VARIABLE.createSalePlanning(params),
    });
  },

  checkExistSalePlan: async (params: ICheckExistSalePlan) => {
    return await axiosGraphQL.post('/graphql', {
      query: SalePlanQuery.CHECK_EXIST_SALE_PLANNING,
      variables: SALE_PLAN_VARIABLE.checkExistSalePlan(params),
    });
  },

  checkCreateSalePlan: async (params: ICheckCreateSalePlan) => {
    return await axiosGraphQL.post('/graphql', {
      query: SalePlanQuery.CHECK_CREATE_SALE_PLANNING,
      variables: SALE_PLAN_VARIABLE.checkCreateSalePlanning(params),
    });
  },
  createDashboard: (params: ICreateSalePlanningAuto) => {
    return axiosGraphQL.post('/graphql', {
      query: SalePlanQuery.QUERY_CREATE_DASHBOARD_TEAM_SALE,
      variables: VARIABLE_CREATE_DASHBOARD_TEAM_SALE(params),
    });
  },
  deleteCustomerInSalePlan: async ({
    cusSalePlantId,
  }: IDeleteCustomerInSalePlan) => {
    return axiosGraphQL.post('/graphql', {
      query: DEL_CUSTOMER_BY_ID,
      variables: {
        input: {
          id: cusSalePlantId,
          useYn: false,
        },
      },
    });
  },
  getDashboardTeamSale: ({
    dayInMonth,
    month,
    teamSaleId,
    year,
  }: IGetDashboardTeamSale) => {
    return axiosGraphQL.post('/graphql', {
      query: SalePlanQuery.QUERY_GET_DASHBORAD_TEAMSALE,
      variables: VARIABLE_GET_DASHBORAD_TEAMSALE({
        teamSalesId: teamSaleId,
        gt: dayjs(`${year}-${month}-01`).format('YYYY-MM-DD'),
        lt: dayjs(`${year}-${month}-${dayInMonth}`).format('YYYY-MM-DD'),
      }),
    });
  },
  updateManySalePlanningCustomerRevenue: (
    params: IUpdateManySalePlanningCustomerRevenue[],
  ) => {
    return axiosGraphQL.post('/graphql', {
      query: SalePlanQuery.UPDATE_MANY_SALE_PLANNING_CUSTOMER,
      variables:
        SALE_PLAN_VARIABLE.updateManySalePlanningCustomerRevenue(params),
    });
  },
};

export default SalePlanApi;
